import request from "@/utils/request";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;

export function getUserInfo() {
    return request({
        url: `${BASE_API}/api/user`,
        method: "get",
    });
}

export function getUserCode(url, params) {
  return request({
    // url: `https://radartest.mktindex.com/api/wxacodeunlimit`,
    url: url,
    method: "get",
    params
  })
}

export function getAgentLogin(url, params) {
  return request({
    // url: `https://radartest.mktindex.com/api/check_agent_login`,
    url: url,
    method: "get",
    params
  })
}

export function postWxMiniLogin(params) {
    return request({
        url: `${BASE_API}/api/wxmini_login`,
        method: "post",
        data: params
    });
}
